export const loginFields = [
  {
    name: "email",
    label: "Електронна пошта*",
    type: "email",
    placeholder: "Введіть ваш email ",
    text: "",
  },
  {
    name: "password",
    label: "Пароль*",
    type: "password",
    placeholder: "Введіть пароль",
    text: "Забули пароль?",
  },
];

export const registerFields = [
  {
    name: "firstName",
    label: "Ваше ім’я*",
    type: "text",
    placeholder: "Ім’я",
    text: "",
  },
  {
    name: "lastName",
    label: "Ваше прізвище*",
    type: "text",
    placeholder: "Прізвище",
    text: "",
  },
  {
    name: "phone",
    label: "Номер телефону*",
    type: "phone",
    placeholder: "+380",
    text: "",
  },
  {
    name: "email",
    label: "Електронна пошта*",
    type: "email",
    placeholder: "Ваш email",
    text: "",
  },
  {
    name: "password",
    label: "Пароль*",
    type: "password",
    placeholder: "Створіть ваш пароль",
    text: "Пароль має містити не менше восьми знаків без урахування пробілів на початку та в кінці.",
  },
  {
    name: "confirmPassword",
    label: "",
    type: "password",
    placeholder: "Повторіть ваш пароль",
    text: "",
  },
];
